export const constants = {
  toolbarZIndex: 8,
  subnavZIndex: 9,
  menuZIndex: 10,

  subnavTransitionDuration: 200,
} as const;
